import { orderIdByChannel, reportPurchaseGtm } from "@utils/member/purchaseGtm";
import type { OpenPlanResumeDraftGoalChatParams } from "@hooks/plan/usePlanGoalChatOpen";
import { trackObPaywallPurchaseSuccess } from "./onboardingAnalytics";
import { consumeOnboardingCheckout } from "./onboardingCheckoutContinuation";

export function resumeOnboardingCheckout(
  ownerId: string,
  attemptId: string,
  openDraft: (draft: OpenPlanResumeDraftGoalChatParams) => void,
): void {
  const checkout = consumeOnboardingCheckout(ownerId, attemptId);
  if (!checkout) {
    return;
  }
  reportPurchaseGtm({
    orderId: orderIdByChannel(checkout.channel),
    plan: checkout.product,
  });
  trackObPaywallPurchaseSuccess(checkout.analyticsSource, checkout.product.id);
  openDraft(checkout.draft);
}
